import React, { lazy, Suspense, useEffect, useReducer } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import moment from 'moment-timezone';
import { AppContext, appReducer, withLocalStorageCache, getInitialState } from './utils/reducers';
import useScript from './utils/useScript';
import hellomailClient from './api/hellomailClient';
import AuthRoute from './components/AuthRoute';
import Loader from './components/Loader';
import HeadsUp from './components/HeadsUp';
import ScrollToTop from './components/ScrollToTop';

const Home = lazy(() => import('./views/Home'));
const AppLayout = lazy(() => import('./views/layouts/AppLayout'));
const AuthLayout = lazy(() => import('./views/layouts/AuthLayout'));
const Builder = lazy(() => import('./views/Builder'));


const App = (props) => {
  const [state, dispatch] = useReducer(withLocalStorageCache(appReducer), getInitialState());

  const hmClient = hellomailClient({ state, dispatch });

  const [chatLoaded, chatError] = useScript('https://wchat.freshchat.com/js/widget.js');

  useEffect(() => {
    if (chatLoaded) {
      window.fcWidget.init({
        token: "53bd1861-7a25-4058-9a8c-c2d64af1fe8c",
        host: "https://wchat.freshchat.com"
      });
    }
  },[chatLoaded]);

  useEffect(() => {
    if (state.user.isAuthenticated) {
      hmClient.get(`/sites/${state.user.siteId}/groups?order_by=name&order_dir=asc&limit=250`)
        .then(response => {
          const data = response.data;
          dispatch({ type: 'SET_GROUPS', payload: data.items });
        })
        .catch((error) => {
          console.log(error);
        });

        if (state.user.currentSite?.siteId !== state.user.siteId) {
          hmClient.get(`/sites/${state.user.siteId}/site_setting`)
            .then(response => {
              let data = response.data;
              if (data.timezone) {
                data.timezoneAbbr = moment.tz(data.timezone).zoneAbbr();
              } else {
                data.timezone = 'Etc/UTC';
                data.timezoneAbbr = 'UTC';
              }
              dispatch({ type: 'UPDATE_CURRENT_SITE', payload: data });
            })
            .catch((error) => {
              console.log(error);
            });
        }
    }
  }, [state.user.siteId]);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<Loader title="Loading..." />}>
          <Switch>

            <Route exact path="/" component={Home} />
            <Route path={['/login', '/signup', '/forgot']} component={AuthLayout} />

            <AuthRoute path="/campaigns/edit/:campaignId/builder/:emailId?/:duplicate?" component={Builder} />
            <AuthRoute path="/welcome-series/builder/:emailId?/:duplicate?" component={Builder} />
            <AuthRoute component={AppLayout} />

          </Switch>
        </Suspense>
      </Router>

      <HeadsUp />
    </AppContext.Provider>
  )
}

export default App;